<template>
  <div class="layout">
    <NavBar v-if="showNavBar" :title="title" :showShopCart="showShopCart"/>
    <router-view v-slot="{ Component }">
      <keep-alive :include="includeNames" :max="1">
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <TabBar v-if="showTabBar" :active="active"/>
    <BackTop v-if="showBackTop"/>
  </div>
</template>

<script>
import {defineComponent, ref, watch} from "vue";
import {NavBar, TabBar} from '../common';
import BackTop from "./BackTop";
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  name: "Layout",
  components: {
    NavBar,
    TabBar,
    BackTop,
  },
  setup() {
    const showNavBar = ref(true); // 顶部导航栏
    const showTabBar = ref(true); // 带底部标签栏
    const active = ref(0); // 底部标签索引
    const title = ref(''); // 顶部标题
    const showShopCart = ref(false); // 顶部右侧购物车
    const showBackTop = ref(false); // 返回顶部
    const route = useRoute();
    const router = useRouter();
    const includeNames = ref([]);
    const initFrame = () => {
      const meta = route.meta;
      if (meta) {
        if (meta.tabBar) {
          showTabBar.value = meta.tabBar.show;
          active.value = meta.tabBar.active;
        }
        if (meta.navBar) {
          showNavBar.value = meta.navBar.show;
          title.value = meta.navBar.title;
          showShopCart.value = meta.navBar.showShopCart;
        }
        showBackTop.value = meta.backTop;
      }
    };
    watch(
        () => route.fullPath, () => {
          initFrame();
        },
        {immediate: true}
    );
		router.beforeEach((to, from) => {
			// 下面操作主要是为了解决数据刷新问题
			// 如果要to(进入)的页面是需要keepAlive缓存的，把name push进include数组中
			if (to.meta.keepAlive) {
				!includeNames.value.includes(to.name) && includeNames.value.push(to.name);
			}
			// 如果 要 form(离开) 的页面是 keepAlive缓存的，
			// 再根据 depth 来判断是前进还是后退
			// 如果是后退就去除
			if (from.meta.keepAlive && to.meta.depth < from.meta.depth) {
				const index = includeNames.value.indexOf(from.name);
				index !== -1 && includeNames.value.splice(index, 1);
			}
		})
    return {
      showNavBar,
      showTabBar,
      initFrame,
      active,
      title,
      showShopCart,
      showBackTop,
			includeNames
    }
  },
});
</script>

<style scoped lang="less">
/*页面容器*/
.layout {
  position: relative;
  height: 100%;
}
</style>
